// A new board's name (Fixes 9, 28 Oct): the one the user typed, or its kind's or template's name when none is free of
// every other board's. A second Content calendar is "Content calendar 2", never a twin of the first.

const key = (s: string) => s.replace(/\s+/g, " ").trim().toLowerCase();

/** The longest a board's name is kept, everywhere it is typed or set: New board, Rename, the server, an agent (Fixes 9). */
export const BOARD_NAME_MAX = 80;

/** A name no board in taken has: name itself when it is free, else "name 2", "name 3" and so on (case and spaces ignored). */
export function freeName(name: string, taken: Iterable<string>): string {
  const base = name.replace(/\s+/g, " ").trim() || "New board";
  const used = new Set([...taken].map(key));
  if (!used.has(key(base))) return base;
  // "Clients 2" asked for again starts from Clients, so the next is "Clients 3", not "Clients 2 2"
  const m = /^(.*\S)\s+(\d{1,4})$/.exec(base);
  const stem = m ? m[1] : base;
  for (let n = m ? Number(m[2]) + 1 : 2; n < 10_000; n++) {
    const next = `${stem} ${n}`;
    if (!used.has(key(next))) return next;
  }
  return `${stem} ${Date.now() % 100_000}`;
}

/** What a board is called, as typed: one line, its spaces tidied, up to 80 characters; empty when nothing was typed. */
export function cleanBoardName(raw: unknown): string {
  return typeof raw === "string" ? raw.replace(/[\r\n\t]+/g, " ").replace(/\s+/g, " ").trim().slice(0, BOARD_NAME_MAX) : "";
}
